<div class="visit-table-cell-date" style="{{ minWidth ? 'min-width:' +minWidth : ''}}" [formGroup]="parentForm">
  <mat-form-field appearance="fill">
    <input #input matInput [matDatepicker]="picker" [formControlName]="controlName" maxlength="10">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
